module.exports = __webpack_public_path__ + "img/whatsapp.738bcfd9.png";